<template>
  <RfSimpleCard class="rf-custom-web-card-wrapper p-10">
    <component
      :is="codeEditor.CodeEditor"
      v-model="styleValues"
      v-bind="codeEditor.props"
    ></component>
  </RfSimpleCard>
</template>

<script>
import RfSimpleCard from "@/components/RfSimpleCard.vue";
import { useAppsStore } from "@/pinia/appsStore";
import { useCodeEditor } from "@/utils/composables/useCodeEditor";

export default {
  name: "RfCssStyles",
  components: { RfSimpleCard },
  setup: () => ({ appsStore: useAppsStore(), codeEditor: useCodeEditor() }),
  data: () => ({ success: false, newStyles: null }),
  computed: {
    styleValues: {
      get() {
        if (this.newStyles) {
          return this.newStyles;
        }
        if (this.appsStore.app) {
          return JSON.stringify(this.appsStore.app.styles, null, "\t");
        }
        return null;
      },
      set(styles) {
        this.newStyles = styles;
      },
    },
  },
  methods: {
    fillModel(model) {
      model.styles = JSON.parse(this.newStyles);
      this.newStyles = null;
    },
  },
};
</script>
